// extracted by mini-css-extract-plugin
export default {"placeholder":"DomainCheckValue_placeholder__6O1wi"};